import React, { FC } from "react";

import { ICareerSheetIssue } from "../../../state";
import { PLACEHOLDERS } from "../../../constants/career";

import styles from "./Question.module.scss";

type Props = {
  sheetIssue: ICareerSheetIssue | undefined;
  isSheetCompleted: boolean;
  getAnswerByQuestionId: (id: number) => string | undefined;
  handleChangeAnswers: (questionId: number, value: string) => void;
};

const Question: FC<Props> = ({
  sheetIssue,
  isSheetCompleted,
  getAnswerByQuestionId,
  handleChangeAnswers,
}) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.theme}>
        {`Q${sheetIssue?.id}.`}
        {sheetIssue?.title}
      </p>
      {sheetIssue?.careergear_sheet_questions.map(question => (
        <div key={question.id} className={styles.question}>
          <p className={styles.title}>{question.title}</p>
          <textarea
            className={styles.textarea}
            value={getAnswerByQuestionId(question.id)}
            onChange={e => handleChangeAnswers(question.id, e.target.value)}
            disabled={isSheetCompleted}
            placeholder={PLACEHOLDERS[sheetIssue?.id][question.order_num]}
          />
        </div>
      ))}
    </div>
  );
};

export default Question;
